import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import Breadcrumb from '@/container/Layout/Breadcrumb';
/**
 * 案件共通レイアウトのコンテナ
 * @constructor
 */
export const RfpContainer = (props) => {
    const { breadcrumbs = [], children, className = '', innerClassName = '', isFull = false, titleComponent = '', } = props;
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: breadcrumbs }), titleComponent, _jsx(ContentContainer, Object.assign({ className: clsx('mx-auto', className), isMinWidthFull: isFull, maxWidthPoint: 'xl' }, { children: _jsx("div", Object.assign({ className: clsx('flex flex-wrap justify-center', 'relative', innerClassName) }, { children: children })) }))] }));
};
